import type { TournamentsApi } from '@/v2/api/metadata/tournaments'
import type { DialogConfig } from '@/v2/framework/dialog/types'
import { notify, notifyApiError } from '@/v2/notifications'
import { NXGDSStatusVariant } from '@nsftx/seven-nxg-design-system-backoffice'

export function createDeleteDialog(options: { tournamentsApi: TournamentsApi }): DialogConfig {
  const { tournamentsApi } = options

  return {
    id: 'delete-tournament',
    title: 'Delete tournament',
    description: `Are you sure you want to delete this tournament?`,
    layout: {
      type: 'nxgds-dialog',
      actions: [
        { intent: 'dismiss', label: 'Cancel', variant: 'secondary' },
        { intent: 'submit', label: 'Delete', variant: 'danger' },
      ],
    },
    structure: {
      type: 'flat',
      children: [],
    },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await tournamentsApi.delete(dialogCtx.row?.id)
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" tournament.`,
          })
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" tournament.`)
        }
      },
    },
  }
}
